import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import StaffProfile from "../../HospitalPages/Staff Management/StaffProfile/StaffProfile";
import DutyRoster from "../../HospitalPages/Staff Management/DutyRoster";
import AttendanceandLeaves from "../../HospitalPages/Staff Management/AttendanceandLeaves";
import PayrollIntegration from "../../HospitalPages/Staff Management/PayrollIntegration";
import StaffPerformanceReports from "../../HospitalPages/Staff Management/StaffPerformanceReports";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";
import DoctorAvailability from "../DoctorManagement/DoctorAvailability/DoctorAvailability"

const StaffDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
 const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";

const userRole = decryptedData.userrole || "";

const cardRoles = {
  "Staff Profiles": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Asign Duty / Attendance & Leaves": [ROLES.RECEPTIONIST], 
  "View/Print Staff Availability": [ROLES.RECEPTIONIST],  // only userRole 102 can see
  "Attendance & Leaves": [ROLES.RECEPTIONIST],
  "Payroll Integration": [ROLES.STAFF],
  "Staff Performance Reports": [ROLES.ACCOUNTSECTION],
  
};


  const cards = [
    ...includeCardForRoles(cardRoles["Staff Profiles"], userRole,{
      title: "Staff Profiles",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <StaffProfile />,category: "👨‍⚕️ Staff Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Asign Duty / Attendance & Leaves"], userRole,{
      title: "Asign Duty / Attendance & Leaves",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <DutyRoster />,category: "👨‍⚕️ Staff Data Managament",
    }),
   

...includeCardForRoles(cardRoles["View/Print Staff Availability"], userRole,{
      title: "View/Print Staff Availability",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <DoctorAvailability />,category: "👨‍⚕️ Staff Data Managament",
    }),


    // ...includeCardForRoles(cardRoles["Attendance & Leaves"], userRole,{
    //   title: "Attendance & Leaves",
    //   icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
    //   component: <AttendanceandLeaves />,category: "👨‍⚕️ Staff Data Managament",
    // }),
    ...includeCardForRoles(cardRoles["Payroll Integration"], userRole,{
      title: "Payroll Integration",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <PayrollIntegration />,category: "👨‍⚕️ Staff Data Managament",
    }),

     ...includeCardForRoles(cardRoles["Staff Performance Reports"], userRole,{
      title: "Staff Performance Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <StaffPerformanceReports /> ,category: "👨‍⚕️ Staff Data Managament",
    }),

  ];
//👨‍⚕️ Staff Data Managament
 
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
👨‍⚕️ Staff Data Managament
          </Typography>
        }
      />
    );
  };

export default StaffDashBoard;
